import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireEmailVerification = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user.email_verified) {
    return <Navigate to="/verify-email" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireEmailVerification;
